(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbased-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbased-footer')) {
    customElements.define('urbased-footer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.controller = new AbortController();
        this.media = window.matchMedia('(max-width: 749px)');
        this.groups = Array.from(this.querySelectorAll('[data-uf-group]')).map((group) => ({
          button: group.querySelector('[data-uf-toggle]'),
          title: group.querySelector('[data-uf-title]'),
          panel: group.querySelector('[data-uf-panel]')
        }));
        this.openIndex = -1;
        this.groups.forEach((group, index) => {
          group.button.addEventListener('click', () => {
            if (!this.media.matches) return;
            this.openIndex = this.openIndex === index ? -1 : index;
            this.sync();
          }, { signal: this.controller.signal });
        });
        this.media.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
        this.setAttribute('data-enhanced', '');
        this.sync();
      }
      sync() {
        const mobile = this.media.matches;
        this.groups.forEach((group, index) => {
          const expanded = !mobile || index === this.openIndex;
          group.button.hidden = !mobile;
          group.title.hidden = mobile;
          if (!expanded && group.panel.contains(document.activeElement)) group.button.focus();
          group.button.setAttribute('aria-expanded', String(expanded));
          group.panel.toggleAttribute('data-closed', !expanded);
          group.panel.inert = !expanded;
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller?.abort();
        this.controller = null;
        this.removeAttribute('data-enhanced');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbased-password"] && !Shopify.designMode) return;
  try {
    
  class UrbasedPasswordCountdown extends HTMLElement {
    connectedCallback() {
      const target = Date.parse(this.dataset.launchDate || '');
      if (!Number.isFinite(target) || target <= Date.now()) return;

      this.target = target;
      this.hidden = false;
      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    update() {
      const remaining = this.target - Date.now();
      if (remaining <= 0) {
        this.hidden = true;
        window.clearInterval(this.timer);
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);

      this.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
    }
  }

  if (!customElements.get('urb-password-countdown')) {
    customElements.define('urb-password-countdown', UrbasedPasswordCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
